import {
  Box,
  Flex,
  Text,
  Input,
  InputGroup,
  InputRightElement,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Badge,
  Icon,
  Alert,
  AlertDescription,
  TableContainer,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
  Link,
  VStack,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { FiEdit, FiEye, FiEyeOff, FiInfo, FiSearch, FiRefreshCw, FiPlus } from "react-icons/fi";
import Navbar from "../Components/Navbar/Navbar";
import Sidebar from "../Components/Sidebar";

const initialCategories = [
  {
    name: "Aussie Rules",
    apiName: "Aussie Rules",
    slug: "aussie-rules",
    leagues: 1,
    teams: 18,
    status: true,
  },
  {
    name: "Mixed Martial Arts",
    apiName: "Mixed Martial Arts",
    slug: "mixed-martial-arts",
    leagues: 2,
    teams: 1137,
    status: true,
  },
  {
    name: "Handball",
    apiName: "...",
    slug: "handball",
    leagues: 4,
    teams: 12,
    status: false,
  },
];

const SIDEBAR_WIDTH = "240px";

export default function Categories() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [categories, setCategories] = useState(initialCategories);
  const [editData, setEditData] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    apiName: "",
    slug: "",
  });
  const [searchTerm, setSearchTerm] = useState("");

  const handleEdit = (cat) => {
    setEditData(cat);
    setFormData({
      name: cat.name,
      apiName: cat.apiName,
      slug: cat.slug,
    });
    onOpen();
  };

  const handleAddNew = () => {
    setEditData(null);
    setFormData({
      name: "",
      apiName: "",
      slug: "",
    });
    onOpen();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = () => {
    if (editData) {
      // Update existing
      setCategories((prev) =>
        prev.map((cat) =>
          cat.slug === editData.slug ? { ...cat, ...formData } : cat
        )
      );
    } else {
      // Add new
      const newCategory = {
        ...formData,
        leagues: 0,
        teams: 0,
        status: true,
      };
      setCategories((prev) => [...prev, newCategory]);
    }
    onClose();
  };

  const filteredCategories = categories.filter((cat) =>
    cat.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <>
      <Navbar />
      <Sidebar />
      <Box
        p={{ base: 4, md: 8 }}
        bg="#f8f9fd"
        minH="100vh"
        mt="80px"
        ml={{ base: 0, md: SIDEBAR_WIDTH }}
      >
        {/* HEADER */}
        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          mb={8}
          align={{ base: "flex-start", md: "center" }}
          gap={4}
        >
          <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="700" color="#344767">
            Manage Categories
          </Text>

          <Flex gap={3} w={{ base: "100%", md: "auto" }} direction={{ base: "column", sm: "row" }}>
            <InputGroup maxW={{ base: "100%", sm: "250px" }} size="md">
              <Input
                placeholder="Search name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                bg="white"
                borderRadius="8px"
                border="1px solid #e2e8f0"
                fontSize="sm"
                _focus={{
                  borderColor: "#5e72e4",
                  boxShadow: "0 0 0 1px #5e72e4",
                }}
              />
              <InputRightElement color="gray.400">
                <FiSearch />
              </InputRightElement>
            </InputGroup>

            <Button
              leftIcon={<FiRefreshCw />}
              bg="white"
              variant="outline"
              fontSize="sm"
              borderRadius="8px"
              h="40px"
              borderColor="#e2e8f0"
              _hover={{ bg: "gray.50" }}
            >
              Fetch Categories
            </Button>

            <Button
              leftIcon={<FiPlus />}
              bg="#5e72e4"
              color="white"
              fontSize="sm"
              borderRadius="8px"
              h="40px"
              _hover={{ bg: "#4e62d4" }}
              onClick={handleAddNew}
            >
              Add New
            </Button>
          </Flex>
        </Flex>

        {/* INFO BOX */}
        <Alert
          bg="blue.50"
          borderLeft="4px solid"
          borderColor="blue.400"
          borderRadius="8px"
          mb={8}
          p={4}
        >
          <AlertDescription fontSize="sm" color="blue.800" fontWeight="500">
            If you update the system from an older version and have already
            added categories, please match the list with the Odds API Sports
            List and update the “Name in API” field if it matches.
          </AlertDescription>
        </Alert>

        {/* DESKTOP TABLE */}
        <Box
          bg="white"
          borderRadius="12px"
          boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.1)"
          overflow="hidden"
          border="1px solid #f0f2f5"
          display={{ base: "none", md: "block" }}
        >
          <TableContainer overflowX="auto">
            <Table variant="simple" size={{ base: "sm", md: "md" }}>
              <Thead bg="#1f15da">
                <Tr>
                  <Th color="white" fontSize="xs" py={4} border="none">NAME</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">NAME IN API</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">SLUG</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">LEAGUES</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">TEAMS</Th>
                  <Th color="white" fontSize="xs" py={4} border="none">STATUS</Th>
                  <Th color="white" fontSize="xs" py={4} border="none" textAlign="right">ACTION</Th>
                </Tr>
              </Thead>

              <Tbody>
                {filteredCategories.map((cat, index) => (
                  <Tr key={index} _hover={{ bg: "#f8f9fa" }}>
                    <Td py={4} fontWeight="700" color="#344767" fontSize="sm">
                      {cat.name}
                    </Td>
                    <Td py={4} color="#67748e" fontSize="xs">{cat.apiName}</Td>
                    <Td py={4} color="#67748e" fontSize="xs">{cat.slug}</Td>
                    <Td py={4} color="#344767" fontWeight="600" fontSize="sm">{cat.leagues}</Td>
                    <Td py={4} color="#344767" fontWeight="600" fontSize="sm">{cat.teams}</Td>

                    <Td py={4}>
                      <Badge
                        bg={cat.status ? "rgba(45, 206, 137, 0.1)" : "rgba(251, 99, 64, 0.1)"}
                        color={cat.status ? "#2dce89" : "#fb6340"}
                        px={3}
                        py={1}
                        borderRadius="full"
                        fontSize="10px"
                        fontWeight="700"
                        textTransform="uppercase"
                      >
                        {cat.status ? "Enabled" : "Disabled"}
                      </Badge>
                    </Td>

                    <Td py={4} textAlign="right">
                      <Flex gap={2} justify="flex-end">
                        <Button
                          size="xs"
                          variant="outline"
                          onClick={() => handleEdit(cat)}
                          borderColor="#e2e8f0"
                          borderRadius="6px"
                          fontSize="xs"
                          leftIcon={<FiEdit />}
                          _hover={{ bg: "gray.50" }}
                        >
                          Edit
                        </Button>

                        <Button
                          size="xs"
                          colorScheme={cat.status ? "red" : "green"}
                          variant="outline"
                          borderRadius="6px"
                          fontSize="xs"
                          leftIcon={cat.status ? <FiEyeOff /> : <FiEye />}
                        >
                          {cat.status ? "Disable" : "Enable"}
                        </Button>
                      </Flex>
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </Box>

        {/* MOBILE CARD VIEW */}
        <VStack display={{ base: "flex", md: "none" }} spacing={4} align="stretch">
          {filteredCategories.map((cat, index) => (
            <Box
              key={index}
              bg="white"
              p={4}
              borderRadius="12px"
              boxShadow="sm"
              border="1px solid"
              borderColor="gray.200"
            >
              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Name
                </Text>
                <Text fontSize="sm" color="#344767">
                  {cat.name}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Name in API
                </Text>
                <Text fontSize="sm" color="#67748e">
                  {cat.apiName}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Slug
                </Text>
                <Text fontSize="sm" color="#67748e">
                  {cat.slug}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Box mb={3} display="flex" justifyContent="space-between" alignItems="center">
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Icon
                </Text>
                <Icon as={FiInfo} color="gray.400" boxSize={5} />
              </Box>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Leagues
                </Text>
                <Text fontSize="sm" fontWeight="600" color="#344767">
                  {cat.leagues}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Teams
                </Text>
                <Text fontSize="sm" fontWeight="600" color="#344767">
                  {cat.teams}
                </Text>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center" mb={3}>
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Status
                </Text>
                <Badge
                  bg={
                    cat.status
                      ? "rgba(45, 206, 137, 0.1)"
                      : "rgba(251, 99, 64, 0.1)"
                  }
                  color={cat.status ? "#2dce89" : "#fb6340"}
                  px={3}
                  py={1}
                  borderRadius="full"
                  fontSize="10px"
                  fontWeight="700"
                  textTransform="uppercase"
                >
                  {cat.status ? "Enabled" : "Disabled"}
                </Badge>
              </Flex>
              <Box borderBottom="1px solid" borderColor="gray.100" mb={3} />

              <Flex justify="space-between" align="center">
                <Text fontSize="sm" fontWeight="700" color="#344767">
                  Action
                </Text>
                <Flex gap={2}>
                  <Button
                    size="xs"
                    variant="outline"
                    onClick={() => handleEdit(cat)}
                    borderColor="#e2e8f0"
                    borderRadius="6px"
                    fontSize="xs"
                    leftIcon={<FiEdit />}
                    _hover={{ bg: "gray.50" }}
                  >
                    Edit
                  </Button>
                  <Button
                    size="xs"
                    colorScheme={cat.status ? "red" : "green"}
                    variant="outline"
                    borderRadius="6px"
                    fontSize="xs"
                    leftIcon={cat.status ? <FiEyeOff /> : <FiEye />}
                  >
                    {cat.status ? "Disable" : "Enable"}
                  </Button>
                </Flex>
              </Flex>
            </Box>
          ))}
        </VStack>

        {/* EDIT MODAL */}
        <Modal isOpen={isOpen} onClose={onClose} size={{ base: "sm", md: "xl" }} isCentered>
          <ModalOverlay backdropFilter="blur(4px)" />
          <ModalContent borderRadius="16px" mx={4}>
            <ModalHeader borderBottom="1px solid #f0f2f5" py={4} color="#344767">
              <Text fontSize="lg" fontWeight="700">
                {editData ? "Edit Category" : "Add New Category"}
              </Text>
            </ModalHeader>
            <ModalCloseButton top={4} />
            <ModalBody p={{ base: 5, md: 8 }}>
              <VStack spacing={6} align="stretch">
                <Alert
                  bg="blue.50"
                  borderRadius="12px"
                  p={4}
                  alignItems="start"
                >
                  <Box>
                    <Text fontWeight="700" fontSize="sm" mb={1} color="blue.800">
                      Automatic Add Info
                    </Text>
                    <Text fontSize="xs" lineHeight="tall" color="blue.700">
                      You can manually add new categories here or import them
                      from the API. If the "Name in API" field matches the Odds
                      API sports group name, all leagues in that category will
                      be automatically fetched when the Fetch Leagues cron job
                      runs on the server. Otherwise, you will need to add them
                      manually.{" "}
                      <Text as="span" color="red.500" fontWeight="600">
                        If the "Name in API" does not match the sports group
                        name in the Odds API, leagues for that category cannot
                        be fetched.
                      </Text>{" "}
                      <Link color="#5e72e4" fontWeight="600">
                        Click here to see the Odds API sports group names
                      </Link>
                    </Text>
                  </Box>
                </Alert>

                <FormControl isRequired>
                  <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">NAME</FormLabel>
                  <Input
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Enter name"
                    h="45px"
                    borderRadius="8px"
                    borderColor="#e2e8f0"
                    fontSize="sm"
                    _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                  />
                </FormControl>

                <FormControl>
                  <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">NAME IN API</FormLabel>
                  <Input
                    name="apiName"
                    value={formData.apiName}
                    onChange={handleChange}
                    placeholder="Enter API name"
                    h="45px"
                    borderRadius="8px"
                    borderColor="#e2e8f0"
                    fontSize="sm"
                    _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                  />
                  <Flex mt={2} align="start" gap={2}>
                    <Icon as={FiInfo} color="gray.400" mt={1} />
                    <Text fontSize="xs" color="#8898aa" lineHeight="tall">
                      Use exact name from Odds API "Group" column for accurate data retrieval.{" "}
                      <Link color="#5e72e4" fontWeight="600">View Sports List.</Link>
                    </Text>
                  </Flex>
                </FormControl>

                <FormControl isRequired>
                  <FormLabel fontSize="xs" fontWeight="700" color="#525f7f">SLUG</FormLabel>
                  <Input
                    name="slug"
                    value={formData.slug}
                    onChange={handleChange}
                    placeholder="Enter slug"
                    h="45px"
                    borderRadius="8px"
                    borderColor="#e2e8f0"
                    fontSize="sm"
                    _focus={{ borderColor: "#5e72e4", boxShadow: "0 0 0 1px #5e72e4" }}
                  />
                  <Text fontSize="10px" color="red.400" mt={1} fontWeight="600">
                    * Spaces are not allowed
                  </Text>
                </FormControl>

                <Button
                  bg="#5e72e4"
                  color="white"
                  w="100%"
                  h="45px"
                  fontSize="sm"
                  fontWeight="700"
                  borderRadius="8px"
                  _hover={{ bg: "#4e62d4" }}
                  onClick={handleSubmit}
                  mt={4}
                >
                  Save Category
                </Button>
              </VStack>
            </ModalBody>
          </ModalContent>
        </Modal>
      </Box >
    </>
  );
}
